var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-6 w-6 mr-2",
    width: "800px",
    height: "800px",
    viewBox: "-.5 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Google-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-401 -860)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(401 860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.8273 24c0-1.5243 0.25316-2.9856 0.705-4.3563l-7.9088-6.0395c-1.5414 3.1296-2.4098 6.656-2.4098 10.396 0 3.7365 0.86736 7.2608 2.4066 10.388l7.9045-6.0512c-0.44757-1.3643-0.69752-2.8203-0.69752-4.3371",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.714 10.133c3.3114 0 6.3023 1.1733 8.6523 3.0933l6.8364-6.8267c-4.1659-3.6267-9.5068-5.8667-15.489-5.8667-9.2868 0-17.268 5.3109-21.09 13.071l7.9088 6.0395c1.8223-5.5317 7.0169-9.5104 13.181-9.5104",
    fill: "#EB4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.714 37.867c-6.1645 0-11.359-3.9787-13.181-9.5104l-7.9088 6.0384c3.822 7.7611 11.803 13.072 21.09 13.072 5.7319 0 11.204-2.0352 15.311-5.8485l-7.5072-5.8037c-2.1182 1.3344-4.7855 2.0523-7.8041 2.0523",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.145 24c0-1.3867-0.21364-2.88-0.53409-4.2667h-21.898v9.0667h12.605c-0.63023 3.0912-2.3457 5.4677-4.8004 7.0144l7.5072 5.8037c4.3144-4.0043 7.1205-9.9691 7.1205-17.618",
    fill: "#4285F4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.c0549450bc2250c39edde09609a6b4d1.svg";
export { ForwardRef as ReactComponent };